import styled from 'styled-components';

export const ResultsStyle = styled.div`
    width: 99%;

    .results-container{
        width: 96%;
        display: flex;
        gap: 110px;
        justify-content: center;
        margin-top: 60px;
        margin-left: 40px;
    }

`;

